import {useSyncExternalStore} from 'react';

import {useAssertedContext} from '@pexip/media-components';

import {NotificationContext} from '../contexts/notification.context';
import {notificationPermissionSignal} from '../signals/Notification.signals';

export const useNotificationContext = () =>
    useAssertedContext(NotificationContext);

export const useNotificationPermission = () => {
    const notifications = useNotificationContext();
    return useSyncExternalStore(
        notificationPermissionSignal.add,
        notifications.getPermissionState,
    );
};
